<template>
    <header class="banner" :id="type + '-banner'">
        <div class="container">
            <h1>{{ heading | translate }}</h1>
            <p class="lead h3">{{ description | translate }}</p>
        </div>
    </header>
</template>

<script>
export default {
    name:  'banner',
    props: ['type', 'heading', 'description'],
    data() {
        return {};
    }
};
</script>
